import { CellContext } from "@tanstack/react-table";
import { TagsGrid } from "../../components/shared/TagsGrid";
import { DASH_PLACEHOLDER } from "../../constants/dashPlaceholder";
import { Tag } from "../../types/freight/tag.type";

type ExtendedTag = Tag & {
  color?: string;
};

export function shipmentTagsColumn<TData>(accessorKey = "shipmentsTags") {
  return {
    accessorKey,
    header: "Shipment Tags",
    enableSorting: false,
    cell: ({ getValue }: CellContext<TData, unknown>) => {
      const tags = getValue() as ExtendedTag[] | undefined;
      return tags && tags.length > 0 ? (
        <TagsGrid
          tags={tags.map((tag) => ({
            ...tag,
            colorHex: tag.colorHex || tag.color || "",
          }))}
        />
      ) : (
        DASH_PLACEHOLDER
      );
    },
  };
}
